export const setUrlArrayParam = (paramName: string, values: string[]): void => {
    const url = new URL(window.location.href);

    if (values.length > 0) {
        const paramValue = values.map((value) => encodeURIComponent(value)).join(',');
        url.searchParams.set(paramName, paramValue);
    } else {
        url.searchParams.delete(paramName);
    }

    window.history.replaceState({}, '', url.toString());
};
